package com.merkost.handpass.admin.contract

import com.merkost.handpass.api.dto.admin.AdminStatsResponse
import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

sealed interface StatsState : MVIState {
    data object Loading : StatsState
    data class Content(val stats: AdminStatsResponse) : StatsState
    data class Error(val message: String) : StatsState
}

sealed interface StatsIntent : MVIIntent {
    data object Refresh : StatsIntent
    data class ReactToFocusTick(val tick: Long) : StatsIntent
    data object NavigateToQueue : StatsIntent
}

sealed interface StatsAction : MVIAction {
    data class Navigate(val path: String) : StatsAction
}
